import { style } from '@primeuix/styles/iftalabel';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-iftalabel'
};
var IftaLabelStyle = BaseStyle.extend({
  name: 'iftalabel',
  style: style,
  classes: classes
});

export { IftaLabelStyle as default };
//# sourceMappingURL=index.mjs.map
